import { useCallback } from 'react';
import { firestore } from '../../contexts/FirebaseContext';
import useAuthUsers from '../useAuthUsers';

function useReportError() {
  const { currentUser } = useAuthUsers();
  const reportError = async (dataError) => {
    await firestore.collection('errorReports').add(dataError);
  };

  /**
   *
   * @param {any} error error capture
   * @param {string} errorAction  constant in ticketsErrors.js actionSectionIdentifier
   * @param {section} section constant in ticketsErrors.js  sectionIdentifier
   */
  const reportErrorTodaySync = useCallback(
    ({ error, errorAction, section, description }) => {
      const errorData = {
        error: JSON.stringify(error),
        errorAction,
        section,
        created_at: new Date(),
        updated_at: new Date(),
        description,
        versionApp: localStorage.getItem('versionApp'),
        user_id: currentUser.id
      };
      console.log({ error });

      firestore.collection('errorReports').add(errorData);
    },
    [currentUser.id]
  );

  return { reportError, reportErrorTodaySync };
}
export default useReportError;
